import { html, TemplateResult } from "lit-html";
import { classMap } from "lit-html/directives/class-map";

const ButtonField = (params: ISubmitButton): TemplateResult => {
  const {
    loading,
    additionalClass,
    messages
  } = params;
  const buttonClasses = {
    'jr-button--loading': loading,
    [`jr-button__modal-submit--${additionalClass}`]: !!additionalClass
  }

  return html`
    <div class="row-fluid btn-container">
      <button class="jr-button jr-button-material ${classMap(buttonClasses)}" type="submit" ?disabled=${loading} id="submit-proposal">
        ${messages.JobSeekerSubscriptionDialogActivateButton}
      </button>
    </div>`;
}

export default ButtonField;
